import './index.css';
import { isValidElement } from 'react';

const isIconComponent = (component) => {
    return isValidElement(component) && typeof component.type !== 'string' && 'isIcon' in component?.type;
};

export { isIconComponent };
//# sourceMappingURL=iconTypes.js.map
